import { useState } from "react";

import Petrol_Vehicle_one from "../../../assets/images/1000EFIImg/1000EFInewdoors1.jpg";
import Petrol_Vehicle_two from "../../../assets/images/1000EFIImg/1000EFInewdoors3.jpg";
import Petrol_Vehicle_three from "../../../assets/images/1000EFIImg/1000EFIwithNewdoors1.jpg";
import Petrol_Vehicle_Four from "../../../assets/images/1000EFIImg/1000EFIwithnewdoors2.jpg";
import Petrol_Vehicle_Five from "../../../assets/images/1000EFIImg/1000EFIwithnewdoors3.jpg";
import Electrical_Six from "../../../assets/images/1500EFIImg/ACon1500E(Top).jpg";
import Electrical_Seven from "../../../assets/images/1500EFIImg/AConeTuatara1.jpeg";
import Electrical_Eight from "../../../assets/images/1500EFIImg/AConeTuatara2.jpeg";

import Icon_Point from "../../../assets/png/Icon_Point.png";

const images = [
  Petrol_Vehicle_one,
  Petrol_Vehicle_two,
  Petrol_Vehicle_three,
  Petrol_Vehicle_Four,
  Petrol_Vehicle_Five,
];

const NZPetrolModels = () => {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);

  // Tooltip control
  const [tooltipPos, setTooltipPos] = useState({ x: 0, y: 0 });
  const [showTooltip, setShowTooltip] = useState(false);

  const openSlider = (i) => {
    setIndex(i);
    setOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeSlider = () => {
    setOpen(false);
    document.body.style.overflow = "auto";
  };

  const prevImg = () =>
    setIndex((i) => (i === 0 ? images.length - 1 : i - 1));

  const nextImg = () =>
    setIndex((i) => (i === images.length - 1 ? 0 : i + 1));

  return (
    <>
      <div className="bg-white">
        <div className="custom-container px-[20px] sm:px-[30px] text-start mx-auto">
          <div className="max-w-[1200px] mx-auto">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-5 justify-items-center">

              {/* Image 1 */}
              <div
                onClick={() => openSlider(0)}
                onMouseMove={(e) => {
                  setTooltipPos({ x: e.clientX, y: e.clientY });
                  setShowTooltip(true);
                }}
                onMouseLeave={() => setShowTooltip(false)}
                className="border border-black w-full aspect-square flex items-center justify-center overflow-hidden bg-white cursor-pointer"
              >
                <img
                  src={Petrol_Vehicle_one}
                  alt="Petrol Tuatara 1000 EFI side-by-side UTV – front left angle view"
                  className="w-[98%] h-[98%] object-contain scale-[1.3] mt-[-23px]"
                />
              </div>

              {/* Image 2 */}
              <div
                onClick={() => openSlider(1)}
                onMouseMove={(e) => {
                  setTooltipPos({ x: e.clientX, y: e.clientY });
                  setShowTooltip(true);
                }}
                onMouseLeave={() => setShowTooltip(false)}
                className="border border-black w-full aspect-square flex items-center justify-center overflow-hidden bg-white cursor-pointer"
              >
                <img
                  src={Petrol_Vehicle_two}
                  alt="Petrol Tuatara 1000 EFI UTV front view with cabin doors open"
                  className="w-[98%] h-[98%] object-contain scale-[1.3]"
                />
              </div>

              {/* Image 3 */}
              <div
                onClick={() => openSlider(2)}
                onMouseMove={(e) => {
                  setTooltipPos({ x: e.clientX, y: e.clientY });
                  setShowTooltip(true);
                }}
                onMouseLeave={() => setShowTooltip(false)}
                className="border border-black w-full aspect-square flex items-center justify-center overflow-hidden bg-white cursor-pointer"
              >
                <img
                  src={Petrol_Vehicle_three}
                  alt="Petrol Tuatara 1000 EFI side-by-side utility vehicle – front right angle"
                  className="w-[98%] h-[98%] object-contain scale-[1.3]"
                />
              </div>

              {/* Image 4 */}
              <div
                onClick={() => openSlider(3)}
                onMouseMove={(e) => {
                  setTooltipPos({ x: e.clientX, y: e.clientY });
                  setShowTooltip(true);
                }}
                onMouseLeave={() => setShowTooltip(false)}
                className="border border-black w-full aspect-square flex items-center justify-center overflow-hidden bg-white cursor-pointer"
              >
                <img
                  src={Petrol_Vehicle_Four}
                  alt="Petrol Tuatara 1000 EFI UTV side profile showing rear cargo tray"
                  className="w-[98%] h-[98%] object-contain scale-[1.4] mb-5"
                />
              </div>

              {/* Image 5 */}
              <div
                onClick={() => openSlider(4)}
                onMouseMove={(e) => {
                  setTooltipPos({ x: e.clientX, y: e.clientY });
                  setShowTooltip(true);
                }}
                onMouseLeave={() => setShowTooltip(false)}
                className="border border-black w-full aspect-square flex items-center justify-center overflow-hidden bg-white cursor-pointer"
              >
                <img
                  src={Petrol_Vehicle_Five}
                  alt="Petrol Tuatara 1000 EFI side-by-side UTV front view with dual doors open"
                  className="w-[98%] h-[98%] object-contain scale-[1.3]"
                />
              </div>
              {/* <div className="border border-black w-full aspect-square flex items-center justify-center overflow-hidden bg-white">
              <img
                src={Electrical_Six}
                alt="Electrical Vehicle 4"
                className="w-[98%] h-[98%] object-contain scale-[1.37] transition-transform duration-300 mr-[55px]"
              />
            </div>
            <div className="border border-black w-full aspect-square flex items-center justify-center overflow-hidden bg-white">
              <img
                src={Electrical_Seven}
                alt="Electrical Vehicle 4"
                className="w-[98%] h-[98%] object-contain scale-[1.36] transition-transform duration-300"
              />
            </div>
            <div className="border border-black w-full aspect-square flex items-center justify-center overflow-hidden bg-white">
              <img
                src={Electrical_Eight}
                alt="Electrical Vehicle 4"
                className="w-[98%] h-[98%] object-contain scale-[1.36] transition-transform duration-300 mr-[70px]"
              />
            </div> */}
            </div>
          </div>
        </div>
      </div>

      {/* ================= FULLSCREEN SLIDER MODAL ================= */}
      {open && (
        <div
          className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-[99999]"
          onClick={closeSlider}
        >
          <div className="relative" onClick={(e) => e.stopPropagation()}>
            {/* Close Button */}
            <button
              onClick={closeSlider}
              className="absolute top-[-50px] right-0 text-white text-5xl"
            >
              ×
            </button>

            {/* Left Arrow */}
            <button
              onClick={prevImg}
              className="absolute left-[-60px] top-1/2 -translate-y-1/2 text-white text-6xl"
            >
              ‹
            </button>

            {/* Main Image */}
            <img
              src={images[index]}
              className="max-h-[80vh] max-w-[90vw] object-contain bg-white rounded-lg shadow-xl"
            />

            {/* Right Arrow */}
            <button
              onClick={nextImg}
              className="absolute right-[-60px] top-1/2 -translate-y-1/2 text-white text-6xl"
            >
              ›
            </button>
          </div>
        </div>
      )}

      {/* Tooltip */}
      {showTooltip && (
        <div
          className="fixed z-[99999] bg-black text-white text-[13px] px-3 py-1 rounded-md pointer-events-none"
          style={{ top: tooltipPos.y + 15, left: tooltipPos.x + 15 }}
        >
          Click here to expand
        </div>
      )}
    </>
  );
};
export default NZPetrolModels;
